/* eslint-disable no-case-declarations */
import { useState, useEffect, useContext } from "react";
import {
  Box,
  // CircularProgress,
  DialogTitle,
  Dialog,
  DialogContent,
  Tooltip,
  IconButton,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import TeamInsights from "./TeamInsights.tsx";
import AnalyticsAPIClient from "../../api/analyticsAPIs.ts";
import useDisplaySnackbar from "../../utils/useDisplaySnackbar.tsx";
import { GlobalContext } from "../../context/GlobalContext.tsx";
// import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Legend } from "chart.js";
import "../../styles/common.css";
// import { formatDate } from "../../utils/utils.ts"
// import PieLegendBox from "../Common/PieLegendBox.tsx";
import { DateRangeValue, UserTeamData } from "../../utils/types";
import DownloadReport from "./DownloadReport.tsx";
import CloseIcon from '@mui/icons-material/Close';
import CustomButton from "../Common/Button.tsx";
import AnalyticalAnalysisService from "../../services/analytics/AnalyticsService.ts";
import {convertToUTC} from "../../utils/utils.ts"


ChartJS.register(ArcElement, Legend);

interface AnalyticsProps {
  selectedTab: string;
  selectedUser: any | null;
  newUserTeamData: UserTeamData | null;
  analyticsDateRange: DateRangeValue;
  setAnalyticsDateRange: React.Dispatch<React.SetStateAction<DateRangeValue>>
}
const Analytics = ({
  selectedTab, selectedUser, newUserTeamData, analyticsDateRange
}: AnalyticsProps) => {
  const theme = useTheme();
  const { showSnackbar } = useDisplaySnackbar();
  const [_loadingCallsPie, setLoadingCallsPie] = useState(false);
  const [_loadingClientPie, setLoadingClientPie] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  //const handleDialogOpen = () => setOpenDialog(true);
  const handleDialogClose = () => setOpenDialog(false);
  const [reportData, setReportData] = useState(null);
  const { accountsReports, accountDetails } = useContext(GlobalContext);
  const loggedInProfileOrgId = accountDetails?.profileOrgId ?? "";
  const employeePorId = selectedTab === "my-analytics" ? loggedInProfileOrgId : newUserTeamData?.currentUser || loggedInProfileOrgId;
  const {
    isLoading: isMeetingInsightsLoading,
    isFetching: isMeetingInsightsFetching,
    isSuccess: isMeetingInsightsSuccess,
    isError: isMeetingInsightsError,
    data: _meetingInsightsData,
  } = AnalyticalAnalysisService.useGetCallAnalysis(
    {
      startTime: convertToUTC(analyticsDateRange?.startDate),
      endTime: convertToUTC(analyticsDateRange?.endDate),
      employeePorId,
      isTeamAnalytics: selectedTab === "team-analytics" ? true : false,
    },
    // analyticsDateRange?.startDate && analyticsDateRange?.endDate && employeePorId ? true : false
    false
  );  

  const {
    isLoading: isAccountsInsightsLoading,
    isFetching: isAccountsInsightsFetching,
    isSuccess: isAccountsInsightsSuccess,
    isError: isAccountsInsightsError,
    error: accountsInsightsError,
    data: _accountsInsightsData,
  } = AnalyticalAnalysisService.useGetClientAnalysis(
    {
      startTime: convertToUTC(analyticsDateRange?.startDate),
      endTime: convertToUTC(analyticsDateRange?.endDate),
      employeePorId,
      isTeamAnalytics: selectedTab === "team-analytics" ? true : false,
    },
    // analyticsDateRange?.startDate && analyticsDateRange?.endDate && employeePorId ? true : false
    false
  );


  const {
    isLoading: isClientReportLoading,
    refetch: refetchClientReport,
  } = AnalyticsAPIClient.useGetClientReport(
    {
      view_files: true,
    },
    false
  );

  // Function to handle click and fetch data
const handleDialogOpen = async () => {
  setOpenDialog(true);
  try {
    const response = await refetchClientReport();
    if (response?.data) {
      setReportData(response.data);
    }
  } catch (err) {
    console.error("Failed to fetch client report", err);
  }
};

//   const ratedClients = accountsInsightsData?.data?.ratedClients;
//   const totalClients = accountsInsightsData?.data?.totalClients;
//   const notRatedClients = accountsInsightsData?.data?.notRatedClients;

//   const ratedPercentageRaw = accountsInsightsData?.data?.ratedClientsPercentage;
//   const ratedPercentage = Math.round(ratedPercentageRaw);
//   const nonRatedPercentage = 100 - ratedPercentage;

//  const clientLegendItems = [
//       { label: "rated", displayLabel: "Rated Clients", color: "#bd00cd2e", count: ratedClients, percentage: ratedPercentage },
//       { label: "non-rated", displayLabel: "Not-Rated Clients", color: "#4A4A4A", count: notRatedClients, percentage: nonRatedPercentage },
//   ];

//   const chartDataNew: any = meetingInsightsData?.data;

//   let totalExternalCallDuration = 0;
//   let totalInernalCallDuration = 0;
//   let totalCallDuration = 0;
  
//   chartDataNew?.forEach((entry: any) => {
//     const duration = entry.duration ?? "00:00";
//     const [hours, minutes] = duration.split(":").map(Number);
//     const durationInMinutes = hours * 60 + minutes;
  
//     if (entry.interactionType === "internal") {
//       totalInernalCallDuration = durationInMinutes;
//     } else if (entry.interactionType === "external") {
//       totalExternalCallDuration = durationInMinutes;
//     } else if (entry.interactionType === "total_internal_external") {
//       totalCallDuration = durationInMinutes;
//     }
//   });

//   const externalHours = Math.floor(totalExternalCallDuration / 60);
//   const externalMinutes = totalExternalCallDuration % 60;
//   const formattedExternalDuration = `${externalHours} hrs ${externalMinutes} m`;
//   const internalHours = Math.floor(totalInernalCallDuration / 60);
//   const internalMinutes = totalInernalCallDuration % 60;
//   const formattedInternalDuration = `${internalHours} hrs ${internalMinutes} m`;

//   const externalPercentage = totalCallDuration
//     ? Math.round((totalExternalCallDuration / totalCallDuration) * 100)
//     : 0;

//   const internalPercentage = totalCallDuration
//     ? 100 - externalPercentage
//     : 0;
//    const  callsLegendItems = [
//             { label: "external", displayLabel: "External Calls", color: "#bd00cd2e", count: formattedExternalDuration, percentage: externalPercentage },
//             { label: "internal", displayLabel: "Internal Calls", color: "#4A4A4A", count: formattedInternalDuration, percentage: internalPercentage },
//         ];    

  // const getBackgroundColor = () => {
  //   if(totalExternalCallDuration + totalInernalCallDuration === 0){
  //     return ["#E5E5E5", "#E5E5E5"]
  //   }
  //   return  ["#bd00cd2e", "#4A4A4A"];
  // };
  // const getBackgroundColors = () => {
  //   if(totalClients === 0){
  //     return ["#E5E5E5", "#E5E5E5"]
  //   }
  //   return  ["#bd00cd2e", "#4A4A4A"];
  // };

  // const data = {
  //   labels: ["External Calls", "Internal Calls"],
  //   datasets: [
  //     {
  //       data: [totalExternalCallDuration, totalInernalCallDuration],
  //       backgroundColor: getBackgroundColor(),
  //       borderColor: "transparent",
  //       borderWidth: 3,
  //       hoverOffset: 4,
  //       majorityValue: (() => {
  //         const totalMinutes = totalCallDuration;
  //         return totalMinutes > 0 ? `${Math.floor(totalMinutes / 60)} hrs ${totalMinutes % 60} m` : 'N/A';
  //       })(),

  //       majorityLabel: (() => {
  //         const totalMinutes = totalCallDuration; // Declare totalMinutes here
  //         return totalMinutes > 0 ? "Total Duration" : "No record to display";
  //       })(),
  //     },
  //   ],
  // };

  // const options = {
  //   responsive: true,
  //   maintainAspectRatio: false,
  //   cutout: "85%",
  //   circumference: 180,
  //   rotation: -90,
  //   plugins: {
  //     datalabels: {
  //       display: false, // Prevents values from showing on the pie chart
  //     },
  //     legend: {
  //       display: false,
  //       position: "right" as const,
  //       labels: {
  //         boxHeight: 10,
  //         boxWidth: 10,
  //         padding: 15,
  //         font: {
  //           size: 14,
  //           family: 'var(--font-family)',
  //           weight: 400,
  //         },
  //         color: "black",
  //       },
  //     },
  //     tooltip: {
  //       callbacks: {
  //         label: (tooltipItem: any) => {
  //           const value = tooltipItem.raw;
  //           const hours = Math.floor(value / 60);
  //           const minutes = value % 60;
  //           return ` ${hours} hrs ${minutes} m`;
  //         },
  //       },
  //     },
  //     customCenterText: {
  //       id: "customCenterText",
  //       beforeDraw(chart: any) {
  //         const { ctx, chartArea } = chart;
  //         const { majorityValue, majorityLabel } = chart.data.datasets[0];
  //         ctx.save();
  //         ctx.font = "600 24px 'Inter'";
  //         ctx.fillStyle = "black";
  //         ctx.textAlign = "center";
  //         ctx.textBaseline = "middle";
  //         const majorityValueMarginTop = 30;
  //         const majorityLabelMarginTop = 20;

  //         // Correct the use of template literals
  //         ctx.fillText(majorityValue, chartArea.width / 2, chartArea.height / 2 - 10 + majorityValueMarginTop);
  //         ctx.font = "14px Inter";
  //         ctx.fillText(majorityLabel, chartArea.width / 2, chartArea.height / 2 + 20 + majorityLabelMarginTop);
  //         ctx.restore();
  //       },
  //     },
  //   },
  // };

  // const Clientdata = {
  //   labels: ["Rated Clients", "Not Rated Clients"],
  //   datasets: [
  //     {
  //       data: [ratedClients, notRatedClients], // Updated values
  //       backgroundColor: getBackgroundColors(),
  //       borderColor: "transparent",
  //       borderWidth: 3,
  //       hoverOffset: 4,
  //       //majorityValue: "18", // Always 18
  //       //majorityLabel: "Total Clients Covered", // Fixed label
  //       majorityValue: (() => {
  //         const totalClient = totalClients;
  //         return totalClient > 0 ? totalClient : 'N/A';
  //       })(),

  //       majorityLabel: (() => {
  //         const totalClient = totalClients; // Declare totalMinutes here
  //         return totalClient > 0 ? "Total Clients" : "No record to display";
  //       })(),
  //     },
  //   ],
  // };

  // const Clientoptions = {
  //   responsive: true,
  //   maintainAspectRatio: false,
  //   cutout: "85%",
  //   circumference: 180,
  //   rotation: -90,
  //   plugins: {
  //     datalabels: {
  //       display: false, // Prevents values from showing on the pie chart
  //     },
  //     legend: {
  //       display: false,
  //       position: "right" as const,
  //       labels: {
  //         boxHeight: 10,
  //         boxWidth: 10,
  //         padding: 15,
  //         font: {
  //           size: 14,
  //           family: 'var(--font-family)',
  //           weight: 400,
  //         },
  //         color: "black",
  //       },
  //     },
  //     tooltip: {
  //       callbacks: {
  //         label: (tooltipItem: any) => {
  //           const value = tooltipItem.raw;
  //           return `   ${value}`;
  //         },
  //       },
  //     },
  //     ClientcustomCenterText: {
  //       id: "customCenterText",
  //       beforeDraw(chart: any) {
  //         const { ctx, chartArea } = chart;
  //         const { majorityValue, majorityLabel } = chart.data.datasets[0];
  //         ctx.save();
  //         ctx.font = "600 24px 'Inter'";
  //         ctx.fillStyle = "black";
  //         ctx.textAlign = "center";
  //         ctx.textBaseline = "middle";
  //         const majorityValueMarginTop = 30;
  //         const majorityLabelMarginTop = 20;

  //         ctx.fillText(majorityValue, chartArea.width / 2, chartArea.height / 2 - 10 + majorityValueMarginTop);
  //         ctx.font = "14px Inter";
  //         ctx.fillText(majorityLabel, chartArea.width / 2, chartArea.height / 2 + 20 + majorityLabelMarginTop);
  //         ctx.restore();
  //       },
  //     },
  //   },
  // }; 


  useEffect(() => {
    setLoadingCallsPie(isMeetingInsightsLoading || isMeetingInsightsFetching);
  }, [
    isMeetingInsightsLoading,
    isMeetingInsightsFetching,
    isMeetingInsightsSuccess,
    isMeetingInsightsError
  ]);

  useEffect(() => {
    setLoadingClientPie(isAccountsInsightsLoading || isAccountsInsightsFetching);
    if (isAccountsInsightsError) {
      showSnackbar("error", accountsInsightsError);
    }
  }, [
    isAccountsInsightsLoading,
    isAccountsInsightsFetching,
    isAccountsInsightsSuccess,
    isAccountsInsightsError,
  ]);

  return (
      <Box className="w-full">
        <Box>
          <Box className="flex flex-row items-center justify-end w-full mr-6">
            {/* Download Icon Button */}
            {accountsReports && (
              <Tooltip title="Download Reports" arrow>
                <Box className="ml-1" sx={{marginTop: "12px"}}>
                <CustomButton
                  type="SmallBrandGradient"
                  clickHandler={handleDialogOpen}
                  parent_page="Analytics"
                />
                </Box>
              </Tooltip>
            )}
            <Dialog 
              open={openDialog} 
              onClose={handleDialogClose}
              fullWidth
              maxWidth="md" 
              PaperProps={{
                sx: {
                  position: 'relative', // Needed for close button positioning
                },
              }}
            >
              <DialogTitle>
                Download Reports
              <IconButton
                aria-label="close"
                onClick={handleDialogClose}
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
              </DialogTitle>
              <DialogContent>
              <Box>
              <DownloadReport reportData={reportData} loading={isClientReportLoading} />
              </Box>
              </DialogContent>
            </Dialog>
          </Box>
        </Box>
        <Box className="mainbox">
        <Box
          className="flex flex-col"
          sx={{
            gap: "1rem", //32px
            [theme.breakpoints.down("lg")]: {
              gap: "1rem",
            },
          }}
        >
          <Box
          className="flex flex-col justify-start gap-3"
        >
          </Box>
          <Box className="flex flex-col justify-start">
            {/*
              Temporarily hidden: top analytics pie charts.
              Keeping TeamInsights table visible below as requested.
            */}
            {/* <Box className="layout__pie">
              <div className="relative chart-containers__pie">
                {loadingCallsPie && (
                  <div className="absolute w-full h-[180%] flex items-center justify-center bg-white bg-opacity-50 z-10">
                    <CircularProgress sx={{ color: "#ccc", opacity: 0.5 }} thickness={5} size={60} />
                  </div>
                )}
                <div className="pie-chart__header">
                  <h1 className="pie-chart__title">Time In Interactions</h1>
                  <span className="pie-chart__date">
                    {`${formatDate(analyticsDateRange.startDate)} - ${formatDate(analyticsDateRange.endDate)}`}
                  </span>
                </div>
                <Pie data={data} options={options} plugins={[options.plugins.customCenterText]} />
                <PieLegendBox flag="calls" legendItems={callsLegendItems} />
              </div>
              <span className="layout__divider"></span>
              <div className="relative chart-containers">
                {loadingClientPie && (
                  <div className="absolute w-full h-[180%] flex items-center justify-center bg-white bg-opacity-50 z-10">
                    <CircularProgress sx={{ color: "#ccc", opacity: 0.5 }} thickness={5} size={60} />
                  </div>
                )}
                <div className="pie-chart__header">
                  <h1 className="pie-chart__title">Unique Entities Met With</h1>
                  <span className="pie-chart__date">
                    {`${formatDate(analyticsDateRange.startDate)} - ${formatDate(analyticsDateRange.endDate)}`}
                  </span>
                </div>
                <Pie data={Clientdata} options={Clientoptions} plugins={[Clientoptions.plugins.ClientcustomCenterText]} />
                <PieLegendBox flag="clients" legendItems={clientLegendItems} />
              </div>
            </Box> */}
          </Box>
          <Box className="flex flex-col justify-start ">
              <TeamInsights
                selectedUser={selectedUser}
                selectedTab={selectedTab}
                newUserTeamData={newUserTeamData}
                analyticsDateRange={analyticsDateRange}
              />
          </Box>
        </Box>        
        </Box>
      </Box>
    )
};

export default Analytics;
